(function() {
    'use strict';

    angular.module('order')
        .controller('InvoiceListController', InvoiceListController);

    InvoiceListController.$inject = [
        '$state',
        'searchFilterSrvc',
        'invoiceDataSrvc',
        'orderSrvc',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'invoicePermissionsConst',
        'momentSrvc',
        'dateFormatConst',
        'filterQuerySrvc',
        'downloadLinkSrvc',
        'notificationSrvc',
        'errorNotificationSrvc',
        'invoiceMessageConst',
        'allegroAccountDataSrvc',
        'ksefInvoiceDataSrvc'
    ];

    function InvoiceListController(
        $state,
        searchFilterSrvc,
        invoiceDataSrvc,
        orderSrvc,
        datatableDefaultPageSizeValueConst,
        checkSearchSrvc,
        invoicePermissionsConst,
        momentSrvc, dateFormatConst,
        filterQuerySrvc,
        downloadLinkSrvc,
        notificationSrvc,
        errorNotificationSrvc,
        invoiceMessageConst,
        allegroAccountDataSrvc,
        ksefInvoiceDataSrvc
    ) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.invoiceRows = [];
        self.invoiceCols = [{
            title: 'Nr faktury',
            value: 'number',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nr zamówienia',
            value: 'order',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'E-mail',
            value: 'client_email',
            orderValue: 'order__client__user__email',
            type: 'link',
            linkTo: 'layout.client.details',
            linkParamProp: 'client_pk',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa firmy',
            value: 'company_name',
            type: 'text',
        }, {
            title: 'Źródło',
            value: 'allegro_account_name',
            type: 'text',
        }, {
            title: 'Sklep',
            value: 'company_localization_display',
            type: 'text',
            orderValue: 'order__company_localization',
            searchable: true,
            orderable: true
        }, {
            title: 'Język',
            value: 'lang_display',
            type: 'text',
            orderValue: 'order__lang',
            searchable: true,
            orderable: true
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text',
            orderValue: 'order__currency',
            searchable: true,
            orderable: true
        }, {
            title: 'Netto',
            value: 'net_price',
            type: 'decimal'
        }, {
            title: 'VAT',
            value: 'vat',
            type: 'decimal'
        }, {
            title: 'Brutto',
            value: 'gross_price',
            type: 'decimal',
        }, {
            title: 'Rodzaj faktury',
            value: 'invoice_type_display',
            type: 'text',
        }, {
            title: 'Data wystawienia',
            value: 'issue_date',
            type: 'date',
            searchable: true,
            orderable: true
        }];
        self.summaryCols = {
            'net_price': 'net_price',
            'vat': 'vat',
            'gross_price': 'gross_price'
        };
        self.modelPermissions = invoicePermissionsConst;

        self.extraActions = [{
            class: 'btn btn-primary btn-xs',
            iconClass: 'fa fa-file-pdf-o',
            title: 'Pobierz PDF',
            withLoading: true,
            onClick: function(row) {
                return orderSrvc.getInvoice(row.order, row.invoice_type);
            }
        }];

        self.contextMenu = [{
            text: function ($itemScope, $event, modelValue, text, $li) {
                return !$itemScope.loading ? 'Pobierz PDF' : 'Pobierz PDF <span class="fa fa-spinner fa-spin"></span>'
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                $itemScope.loading = true;
                $itemScope.row.actionLoading === undefined ?
                    $itemScope.row.actionLoading = { 0: true } : $itemScope.row.actionLoading[0] = true;
                return orderSrvc.getInvoice($itemScope.row.order, $itemScope.row.invoice_type).then(
                    function () {
                        $itemScope.loading = false;
                        $itemScope.row.actionLoading[0] = false;
                    },
                    function () {
                        $itemScope.loading = false;
                        $itemScope.row.actionLoading[0] = false;
                    }
                );
            },
            enabled: function ($itemScope, $event, modelValue, text, $li) {
                return !$itemScope.loading;
            }
        }];

        self.dateFormat = dateFormatConst.datePickerWithoutDay;
        self.maxDate = momentSrvc.dateToStr(momentSrvc.getCurrentDate());
        self.filterData = {
            date: self.maxDate,
            without_final: false,
            source: null,
            ksef_number: '',
            ksef_status: null
        };

        self.searchQuery = {
            pk: null,
            order: null,
            client_email: null,
            issue_date: null,
            number: null,
            company_localization_display: null,
            lang_display: null,
            currency: null,
            ordering: null
        };

        self.exposingData = {
            color: {
                'payment_deadline_overdued': '#f8c1c1',
                'done': '#92e7c2',
            },
            conditionProp: 'exposing_value',
            conditionValue: ['payment_deadline_overdued', 'done']
        };
        self.sourceOpts = [
            {
                pk: 'internal',
                name: 'Wewnętrzne'
            }
        ];

        self.statusKsefOpts = [];

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.changeFilter = changeFilter;
        self.getAllegroAccountsOpts = getAllegroAccountsOpts;
        self.getKsefStatusOpts = getKsefStatusOpts;
        self.getCsvInvoices = getCsvInvoices;
        self.getJpkFaInvoices = getJpkFaInvoices;

        activate();

        function activate() {
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getInvoices();
            getAllegroAccountsOpts();
            getKsefStatusOpts()
        }

        function getInvoices(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    pk: self.searchQuery.pk,
                    order: self.searchQuery.order,
                    client_email: self.searchQuery.client_email,
                    issue_date: searchFilterSrvc.getDateValue(self.searchQuery.issue_date),
                    number: self.searchQuery.number,
                    company_localization_display: self.searchQuery.company_localization_display,
                    lang_display: self.searchQuery.lang_display,
                    currency: self.searchQuery.currency,
                    allegro_account_name: self.searchQuery.allegro_account_name,
                    ordering: self.searchQuery.ordering,

                    source: self.filterData.source,
                    date_year: self.filterData.date ?
                        momentSrvc.dateYear(self.filterData.date) : null,
                    date_month: self.filterData.date ?
                        momentSrvc.dateMonth(self.filterData.date) : null,
                    without_final: typeof self.filterData.without_final !== 'undefined' ?
                        self.filterData.without_final : false,
                    ksef_number: self.filterData.ksef_number,
                    ksef_status: self.filterData.ksef_status
                };
            }
            return invoiceDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.invoiceRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getInvoices);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function getAllegroAccountsOpts() {
            self.loading = true;
            return allegroAccountDataSrvc.getFieldOpts()
                .$promise
                .then(
                    function (response) {
                        self.sourceOpts = self.sourceOpts.concat(response.results);
                        return response;
                    }
                ).finally(
                    function (response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function getKsefStatusOpts() {
            return ksefInvoiceDataSrvc.getFieldOpts()
                .$promise
                .then(
                    function (response) {
                        self.statusKsefOpts = response;
                        return response;
                    }
                ).finally(
                    function (response) {
                        return response;
                    }
                );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getInvoices();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getInvoices();
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getInvoices();
        }

        function getCsvInvoices(filterObj) {
            if (!filterObj) {
                filterObj = {
                    date_year: self.filterData.date ? momentSrvc.dateYear(self.filterData.date) : null,
                    date_month: self.filterData.date ? momentSrvc.dateMonth(self.filterData.date) : null,
                    source: self.filterData.source
                };
            }

            if (!filterObj['date_year'] && !filterObj['date_month']){
                notificationSrvc.notification("error", invoiceMessageConst.lackDateFilterCSVError)
                return;
            }

            if (!filterObj['source']){
                notificationSrvc.notification("error", invoiceMessageConst.sourceFilterError)
                return;
            }

            self.loadingCsv = true;
            return invoiceDataSrvc.exportCsv(filterObj)
                .$promise
                .then(
                    function (response) {
                        downloadLinkSrvc.saveFile(response);
                    },
                    function (response) {
                        errorNotificationSrvc.displayErrors(response.data);
                    }
                ).finally(
                    function (response) {
                        self.loadingCsv = false;
                        return response;
                    }
                );
        }

        function getJpkFaInvoices(filterObj) {
            if (!filterObj) {
                filterObj = {
                    date_year: self.filterData.date ? momentSrvc.dateYear(self.filterData.date) : null,
                    date_month: self.filterData.date ? momentSrvc.dateMonth(self.filterData.date) : null,
                    source: self.filterData.source
                };
            }

            if (!filterObj['date_year'] && !filterObj['date_month']){
                notificationSrvc.notification("error", invoiceMessageConst.lackDateFilterJPKFAError)
                return;
            }

            if (!filterObj['source']){
                notificationSrvc.notification("error", invoiceMessageConst.sourceFilterError)
                return;
            }

            self.loadingJpkFa = true;
            return invoiceDataSrvc.exportJpkFa(filterObj)
                .$promise
                .then(
                    function (response) {
                        downloadLinkSrvc.saveFile(response);
                    },
                    function (response) {
                        errorNotificationSrvc.displayErrors(response.data);
                    }
                ).finally(
                    function (response) {
                        self.loadingJpkFa = false;
                        return response;
                    }
                );
        }
    }
})();
